const MAP_ORDER = {
  STANDARD: 1,
  HEAT: 2,
  SIZE: 3,
  COLOR: 4,
};

export default MAP_ORDER;
